module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-precomposed.6d11588ff3c8c013697f0fb899ae6c70.png";